import { shallowEqual, useSelector } from 'react-redux'
import Flex from 'styled-flex-component'

import hooks from '@hooks'
import { IApplicationState } from '@store'
import {
  selectBrandMatchPercentage,
  selectCreatorBioLink,
  selectIsAudienceMatch,
  selectIsSubmissionFromPinterest,
} from '@store/submissions'
import { Container } from '@tribegroup'
import SubmissionCardHeaderAudienceMatch from '../AudienceMatch/AudienceMatch'
import SubmissionCardHeaderBrandMatch from '../BrandMatch'
import { SubmissionCardHeaderTalentAgencyCreatorTag } from '../TalentAgencyCreator/Tag'
import SubmissionCardHeaderViewBio from '../ViewBio'

interface ISubmissionCardHeaderActionsProps {
  campaignId: number
  submissionId: number
}

const SubmissionCardHeaderActions: React.FC<ISubmissionCardHeaderActionsProps> = ({
  submissionId,
  campaignId,
}) => {
  selectIsSubmissionFromPinterest

  const { isPinterest } = useSelector((state: IApplicationState) => ({
    isPinterest: selectIsSubmissionFromPinterest(state, submissionId),
  }), shallowEqual)

  const { isAudienceMatch, creatorBio, brandMatchPct } = useSelector((state: IApplicationState) => {
    return {
      isAudienceMatch: selectIsAudienceMatch(state, submissionId),
      creatorBio: selectCreatorBioLink(state, submissionId),
      brandMatchPct: selectBrandMatchPercentage(state, submissionId),
    }
  }, shallowEqual)

  const isInfluencerView = hooks.useIsInfluencerView()

  const showAudienceMatch = !isPinterest && isAudienceMatch
  const showBrandMatch = !isPinterest && !isInfluencerView && typeof brandMatchPct === 'number'
  const showCreatorBio = !isInfluencerView && creatorBio

  return (
    <Flex alignCenter>
      {showAudienceMatch && (
        <Container rightOuterSpacing={0.5} bottomOuterSpacing={0.125}>
          <SubmissionCardHeaderAudienceMatch submissionId={submissionId} campaignId={campaignId} />
        </Container>
      )}
      {showBrandMatch && (
        <Container rightOuterSpacing={0.5} topOuterSpacing={0.125}>
          <SubmissionCardHeaderBrandMatch
            brandMatchPct={brandMatchPct}
            submissionId={submissionId}
            campaignId={campaignId}
          />
        </Container>
      )}
      {showCreatorBio && (
        <Container rightOuterSpacing={0.5} topOuterSpacing={0.125}>
          <SubmissionCardHeaderViewBio
            href={creatorBio.href}
            method={creatorBio.method}
            submissionId={submissionId}
            campaignId={campaignId}
          />
        </Container>
      )}
      <SubmissionCardHeaderTalentAgencyCreatorTag submissionId={submissionId} />
    </Flex>
  )
}

export default SubmissionCardHeaderActions
